import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useContext } from "react";

import { PageFrame } from "../../components/page_frame";
import { useCustomer } from "../../contexts/app/provider";
import { ApiContext } from "../../contexts/app/context";
import { ROOT_ROLE } from "../../constants/user";

export const ProfilePage = () => {
  const { whoIAm: user } = useCustomer();
  const { actualRole, demoMode, setDemoMode } = useContext(ApiContext);

  // Only show demo mode toggle to ROOT users
  const isRootUser = actualRole?.includes(ROOT_ROLE) ?? false;

  return (
    <PageFrame>
      <Box sx={{ p: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Typography variant="h1">Profile</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 10 },
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Typography>
              <b>Name:</b> {user?.name}
            </Typography>
            <Typography>
              <b>Email:</b> {user?.email}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Typography>
              <b>Role:</b> {user?.role}
            </Typography>
            <Typography>
              <b>CustomerId:</b> {user?.customerId}
            </Typography>
          </Box>
        </Box>
        {isRootUser && (
          <Box
            sx={{
              mt: 4,
              p: 2,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 1,
            }}
          >
            <Typography variant="h6" sx={{ mb: 2 }}>
              Demo Mode
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
              When enabled, the app will display as if you have the ADMIN role
              instead of ROOT. This allows you to see the app from a user's
              perspective.
            </Typography>
            <FormControlLabel
              control={
                <Switch
                  checked={demoMode}
                  onChange={(e) => setDemoMode(e.target.checked)}
                  color="primary"
                />
              }
              label={demoMode ? "Demo Mode: ON " : "Demo Mode: OFF"}
            />
          </Box>
        )}
      </Box>
    </PageFrame>
  );
};
